import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Agentation } from "agentation";
import Home from "./pages/Home";

function App() {
  return (
    <>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </div>
      {process.env.NODE_ENV === "development" && <Agentation />}
    </>
  );
}

export default App;
